import { useState } from "react";
import { isEmailValid } from "../../../../services/textService";
import { MailOutlined } from '@ant-design/icons';
import { FaGoogle } from '@react-icons/all-files/fa/FaGoogle';
import Button from "../../../../components/forms/Button";
import {buildLoginPageUrl, buildAuthCallbackPageUrl} from '../../../../services/urlBuilderService'
import CustomInput from "../../../../components/forms/Input";
import { Form } from "antd";
import {reportEvent} from '../../../../services/analyticsService'
import { t } from '../../../../utils/i18n';

const FillEmail = props => {
    const { email, setEmail, loading } = props;
    const [submitted, setSubmitted] = useState(false)
    const showInvalid = (email.length > 0 || submitted) && !isEmailValid(email.trim())
    const onGetCode = () => {
        reportEvent('auth', 'login_click', {
            type: 'email',
        });
        setSubmitted(true)
        if (!isEmailValid(email)) {
            document.querySelector('#email-input').focus()
            return
        }

        props.onContinue()
        // TODO: Get 6 digit code
    }
    const onGoogleSignin = () => {
        reportEvent('auth', 'login_click', {
          type: 'google',
        });
        const GOOGLE_SCOPES = 'profile email'
        let targetUrl =
          'https://accounts.google.com/o/oauth2/v2/auth?client_id=988681715571-itn3c6d85q678gb0j9jlqpotfebrvfda.apps.googleusercontent.com';
        targetUrl += `&response_type=code`;
        targetUrl += `&redirect_uri=${buildLoginPageUrl(true)}`;
        targetUrl += `&scope=${GOOGLE_SCOPES}`;
        window.location.href = targetUrl;
      };    
    return (
        <>
            <h1>{t('login.welcome')}</h1>
            <br /><br />
            <Button onClick={onGoogleSignin}
                className="social-button google-button"
                block
            >
                <FaGoogle />
                {t('login.continue_with_google')}
            </Button>

            <div className="divider">
                <span>{t('login.or')}</span>
            </div>

            {submitted && !isEmailValid(email) && (
                <div className="error-message">
                    <span>{t('login.invalid_email_format')}</span>
                </div>
            )}
            <Form.Item label={t('login.email_label')}>
                <CustomInput autoComplete="nope"
                    id="email-input"
                    prefix={<MailOutlined />}
                    placeholder={t('login.email_placeholder')}
                    invalid={showInvalid}
                    className={`email-input`} value={email} onChange={e => setEmail(e.target.value.trim())}
                />
            </Form.Item>

            <Button type="primary" block className="continue-button" onClick={onGetCode} loading={loading}>
                {t('login.get_code')}
            </Button>

            <p className="terms-text">
                {t('login.terms')}
            </p>
        </>
    )
}

export default FillEmail;